import React from 'react';
import './AboutMe.css';

const AboutMe = () => {
  return (
    <section className="about-panel" aria-labelledby="about-heading">
      <div className="about-intro">
        <h2 id="about-heading" className="about-greeting">Heyo, I'm <span>Alex.</span></h2>
        <p className="about-roles">I'm an engineer, investor, and founder.</p>
        <p className="about-description">
          I've built some cool things and invest in the best founders defining the future.
        </p>
        <p className="about-signoff">Catch me outside.</p>
      </div>

      <div className="about-experience">
        <h3 className="about-experience-title">Experience</h3>
        <ul className="about-logos" aria-label="Organizations">
          <li>
            <img
              src="/images/BAV_Logo.png"
              alt="Booz Allen Ventures"
              className="about-logo about-logo-bav"
              width="2196"
              height="1082"
              decoding="async"
            />
          </li>
          <li>
            <img
              src="/images/Northrop.svg"
              alt="Northrop Grumman"
              className="about-logo about-logo-northrop"
              width="1200"
              height="408"
              decoding="async"
            />
          </li>
          <li>
            <img
              src="/images/Y_Combinator_logo.png"
              alt="Y Combinator"
              className="about-logo about-logo-yc"
              width="1200"
              height="1200"
              decoding="async"
            />
          </li>
        </ul>
      </div>
    </section>
  );
};

export default AboutMe;
